import { render, staticRenderFns } from "./editCouponPropertyPool.vue?vue&type=template&id=0e454d74"
import script from "./editCouponPropertyPool.vue?vue&type=script&lang=js"
export * from "./editCouponPropertyPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports